export const MIN_DRAWER_HEIGHT = 25;
